import { makeGuardedModal } from 'components/guardedModal/makeGuardedModal';
import { SimpleModalId } from 'constants/modalId';
import { CancelEventModalContentContainer } from './CancelEventModalContentContainer';

export const CancelEventModal = makeGuardedModal(SimpleModalId.CancelEvent, CancelEventModalContentContainer);
